import React from 'react'
import healthcare1 from '../images/uxgenie1.png';
import healthcare2 from '../images/uxgenie2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function RetailNova() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">Retail Nova </span> - AI-Powered Retail Intelligence
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Retail Nova Intelligence Platform"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Retail Nova</span> – AI-Powered Retail Intelligence
                        </h1>

                        <p className="mb-3 ps-1">
                            Retail Nova is a cutting-edge AI and analytics platform built to transform how retailers understand customer behavior,
                            optimize operations, and drive sales. By leveraging powerful machine learning algorithms and real-time data analysis,
                            Retail Nova delivers actionable insights that help businesses stay ahead in today’s competitive retail landscape.
                        </p>

                        <p className="mb-3 ps-1">
                            The platform supports seamless integration with POS systems, e-commerce platforms, and CRM tools to provide a unified
                            view of your business. With features like predictive demand forecasting, customer segmentation, sentiment analysis,
                            and inventory optimization, Retail Nova empowers retail teams to make smarter, data-driven decisions.
                        </p>

                        <p className="mb-4 ps-1">
                            What once required weeks of manual analysis can now be accomplished in minutes—allowing retailers to identify trends,
                            personalize customer experiences, and respond rapidly to market changes.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> FinsightX – Smart Finance Technology Partner
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">UAE</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Objectives & Stack</h4>
                        <p className="mb-3 ps-3">
                            Predictive Analytics, Financial NLP, Dashboard Interfaces, Vue.js, Flask, Neo4j, NumPy, Pandas
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Field of Operation</h4>
                        <p className="mb-3 ps-3">Financial Services / Data Intelligence</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Details</h4>
                        <p className="mb-3 ps-3">
                            Financial Domain Expert, UI Lead, 2 Web Engineers, Backend Specialist, AI Analyst, QA Resource
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Length</h4>
                        <p className="mb-4 ps-3">3 Months</p>

                        <p className="mb-4 ps-3">
                            Retail Nova - AI-Powered Retail Intelligence is designed to accelerate and simplify the complex landscape of
                            pharmaceutical patent analysis. It empowers researchers to swiftly identify alternative molecules and
                            formulations and bypass patents of medicines. Users can upload patent documents and research papers in any language,
                            and the app instantly suggests circumvention strategies—cutting research time from months to days.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Retail Intelligence Dashboard"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Retail Nova Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            Our team designed and developed Retail Nova using AI and machine learning to analyze customer behavior,
                            product performance, and store operations. We integrated retail data sources like POS systems, e-commerce platforms,
                            and CRM tools to create a unified data environment.
                        </p>

                        <p className="mb-3 ps-1">
                            We emphasized intuitive dashboards, predictive analytics, and real-time alerts to help managers make fast,
                            informed decisions. Our design approach ensured scalability, seamless UX, and insights that could drive
                            measurable results across departments.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">AI-powered customer behavior analytics</li>
                            <li className="mb-1">Predictive inventory and demand forecasting</li>
                            <li className="mb-1">Real-time sales trend and performance tracking</li>
                            <li className="mb-1">Centralized dashboard with cross-platform data integration</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default RetailNova